import { addDoubleQuotes, toStringifyWithoutQuotes } from '../utils/smartutils';

export function medicationListByFilter() {
  const query = `{
  medicationListByFilter(filter: {}) {
    id
    name
    status
    requestDate
    requester
    student {
      fullName
    }
  }
}
`;

  return query;
}

export function medicationListByStudent(studentId) {
  const query = `{
    medicationListByFilter(filter: {studentId: ${studentId}}){
        id, name,initialDate, finalDate, photoRecipeUrl,
        student{fullName}
    }
}`;
  return query;
}

export function medicationListById(id) {
  const query = `{ medicationListByFilter(filter: {id: ${id}}){
        id, name, dosage, routeAdministration, observation, initialDate, finalDate, hour01, hour02, hour03, hour04, hour05, requestDate, requester, photoRecipeUrl, employeeCreatorMed,
        student{id, fullName, dateOfBirth}, photoRecipeMimeType
    }}`;
  return query;
}

export function saveMutation(values, file) {
  const mutationQuery = `mutation {    
    medicationSave(medication: {
                id: ${values.id ? values.id : 0},
                name: "${values.name}",
                dosage: "${values.dosage}",
                routeAdministration: "${values.routeAdministration}",
                observation: ${addDoubleQuotes(values.observation)},
                initialDate: ${
                  values.initialDate ? values.initialDate.getTime() : 0
                },
                finalDate: ${values.finalDate ? values.finalDate.getTime() : 0},
                hour01: "${values.hour01}",
                hour02: "${values.hour02 ? values.hour02 : ''}",
                hour03: "${values.hour03 ? values.hour03 : ''}",
                hour04: "${values.hour04 ? values.hour04 : ''}",
                hour05: "${values.hour05 ? values.hour05 : ''}",
                requestDate: ${values.requestDate ? values.requestDate : 0},
                requester: "${values.requester ? values.requester : ''}",
                fileId: "${file ? file.fileId : ''}",
                employeeCreatorMed: ${
                  values.employeeCreatorMed ? values.employeeCreatorMed : 0
                },
                student: {
                    id: ${values.student.id},
                    filterByStatus: false, 
                    updaterId: 0, 
                    active: false, 
                    legacyId: 0,
                    dateOfBirth: 0,
                    activeOnLoggedPeriod: true

                }
                filterByStatus: false,
                updaterId: 0,
                deviceId: 0
    }){id}
}`;
  return mutationQuery;
}

export function removeMedicationMutation(id) {
  const query = `mutation 
{
    medicationRemove(medicationId: ${id})    
}`;
  return query;
}

export function medicationListByMedicationFilter(filter) {
  const { student, ...rest } = filter;
  const filterReassign = { ...rest };
  if (student && student.id) {
    filterReassign.studentId = student.id;
  }
  if (filter.hasRecipe) {
    filterReassign.filterByHasRecipe = filter.hasRecipe;
  }
  return `{
  medicationListByMedicationFilter(filter: ${toStringifyWithoutQuotes(
    filterReassign
  )}) {
    id
    name
    status
    requestDate
    requester
    student {
      fullName
    }
  }
}`;
}
